import _ from "lodash";
import {
  Component,
} from "react";
import {
  Button,
  ButtonToolbar,
  Col,
  Container,
  Row,
  Table,
} from "react-bootstrap";
import {
  withLocation,
} from "CommonCore/router-util";
import store from "CommonState/store";
import moment from "moment";

import {
  EditPanel,
  Spinner,
  Tooltip,
} from "CommonComponents/bricks";
import {
  ANTRAGSTYPEN,
  VERTRAGSARTEN_LEHRAUFTRAG,
} from "../constants";
import apifetch from "CommonCore/apifetch";

import Breadcrumb from "CommonComponents/breadcrumb";
import ReportBase, {
  exportReport,
} from "./report-base";

export default class ReportLehraufträge extends ReportBase {
  constructor() {
    super();
    this.rows = {};
    this.state = { rows: [], headers: [], updateId: 0 };

    this.criteria = { jahr: String(moment().year()), semester: "04-01" };
  }

  storeTable = table => {
    this.rows = table;
  };
  storeHeaders = headers => {
    this.headers = headers;
  };

  componentDidMount() {
    // this.onUpdate();
  }

  render() {
    const { inflight, filtered } = this.state;

    const jahr = moment().year();

    const schema = {
      table: [
        {
          field: "semester",
          display: "Semester",
          type: "select",
          choices: [{ label: "Sommer", value: "04-01" }, { label: "Winter", value: "10-01" }],
        },
        {
          field: "jahr",
          display: "Jahr",
          type: "select",
          choices: _.range(jahr - 5, jahr + 5).map(x => {
            return { label: x.toString(), value: x.toString() };
          }),
        },
      ],
    };

    return <Container fluid>
      <Row>
        <Col xs={6}>
          <EditPanel
            editable
            defaultEditable
            entity={this.criteria}
            header={<h4 key='h4'>Kriterien</h4>}
            schema={schema}
            submitText='Auswertung starten'
            onSave={this.onUpdate}
            onChange={this.onChange}
            noToggleOnSave
            hideCancel
          />
        </Col>
      </Row>
      {filtered && <div style={{ marginTop: "6px", marginBottom: "6px" }}>
        <ButtonToolbar className='align-right'>
          <Button className='float-end' disabled={_.isEmpty(filtered)} style={{ marginLeft: "1em" }} onClick={this.exportData}>
            <Tooltip overlay='Daten als XLSX exportieren'>Exportieren {!_.isEmpty(filtered) ? `(Anzahl ${ filtered.length })` : "" }</Tooltip></Button>
        </ButtonToolbar>

      </div>}


      <Breadcrumb name='Auswertung Lehraufträge Neu' route='/auswertung/lehraufträge' />

      {inflight && <Spinner />}

      {!inflight && filtered &&

        <ReportLehraufträgeTable
          {...this.props}
          data={filtered}
          updateId={this.state.updateId}
          onTableUpdated={this.storeTable}
          onHeadersUpdated={this.storeHeaders}
        />
      }
    </Container>;
  }

  onChange = change => {
    const { criteria } = this;
    _.assign(criteria, change);
  };

  onUpdate = () => {
    const { updateId } = this.state;
    const { criteria } = this;

    this.setState({ inflight: true }, async() => {
      // Backend alles filtern lassen, was es kann
      const url = `/api/shkantrag/antrag?abgeschlossen=1&artid=${ VERTRAGSARTEN_LEHRAUFTRAG[0] }`;
      const list = await apifetch(url);

      // Frontend den Rest filtern lassen
      const filtered = _.filter(list.data, antrag => antrag.a_katid == ANTRAGSTYPEN.NEUEINSTELLUNG && _.find(antrag.massnahmen, m => m.m_gueltigab == `${ criteria.jahr }-${ criteria.semester }`));

      this.setState({ filtered, inflight: false, updateId: updateId + 1 });
    });
  };

  exportData = () => {
    // Export starten
    exportReport(this.rows, this.headers);
  };
}

@withLocation
@store("einrichtungTreeVisible", "k_anredeLookup", "k_finanzamtLookup", "k_einrichtungLookup")
class ReportLehraufträgeTable extends Component {
  constructor() {
    super();
    this.state = {};
  }

  getHeaderList = () => {
    // Header-Texte liefern (hier statisch, kann aber in anderen Report dynamisch sein)
    return [
      "ZP-Nr.",
      "PFI-Serial",
      "Semester",
      "Kostenst.",
      "Vergütung",
      "FK",
      "Ges.betrag",
      "IBAN",
      "BIC",
      "Anrede",
      "Name",
      "Vorname",
      "Geburtsdatum",
      "Straße/Hausnummer",
      "PLZ",
      "Ort",
      "Steuer-ID",
      "Finanzamt",
      "Anschrift",
      "Fakultät/ZE",
    ];
  };

  render() {
    const { data, inflight, k_anredeLookup, k_finanzamtLookup } = this.props;

    if (!k_anredeLookup || !k_finanzamtLookup) {
      return null;
    }

    this.rows = data;

    const tableContent = this.renderRows(this.rows, null);
    this.props.onTableUpdated && this.props.onTableUpdated(tableContent); // Daten an Parent melden

    const headers = this.getHeaderList();
    this.props.onHeadersUpdated && this.props.onHeadersUpdated(headers); // Headers an Parent melden

    return <div>
      <Table size='sm' bordered hover>
        <thead>
          <tr style={{ backgroundColor: "#ddd" }}>
            {_.map(headers, (text, i) => <th key={"header-" + i} className='delineated-header'>{text}</th>)}
          </tr>
        </thead>
        <tbody>
          {!inflight && tableContent }


        </tbody>
      </Table>
      {_.isEmpty(this.rows) && <h3>Keine Daten</h3>}
      {inflight && <Spinner />}
    </div>;
  }

  renderRows(data) {
    // -- Daten in Tabellenform ausgeben'
    const { k_anredeLookup, k_finanzamtLookup, k_einrichtungLookup } = this.props;

    if (!k_anredeLookup || !k_finanzamtLookup || !k_einrichtungLookup) {
      return null;
    }

    const rows = _.map(data, antrag => {
      const p = antrag.antrag_person[0];

      const fa = p.ap_kffid && k_finanzamtLookup?.[p.ap_kffid];
      const fa_anderes = p.ap_kffanderes; // Hier ist ein JSON für ein im katalog unbekanntes Finanzamt gespeichert

      const fields = [
        "",
        "",
        "",
        "",
        "",
        "",
        "", // leere Tabellenfelder
        p.ap_iban,
        p.ap_bic,
        String(k_anredeLookup?.[p.ap_kanid]?.kan_kbez),
        p.ap_name,
        p.ap_vorname,
        new moment(p.ap_gebdatum).format("DD.MM.YYYY"),
        p.ap_str,
        p.ap_plz,
        p.ap_ort,
        p.ap_steuerid,
        !fa_anderes ? fa?.kff_gebiet : fa_anderes.gebiet,
        !fa_anderes
? `${ fa?.kff_str }, ${ fa?.kff_plz } ${ fa?.kff_ort }`
                   : `${ fa_anderes.str }, ${ fa_anderes.plz } ${ fa_anderes.ort }`,
        k_einrichtungLookup?.[antrag.a_fakultaet_eid]?.e_kbez,
      ];

      return <tr>{_.map(fields, f => <td>{f}</td>)}</tr>;
    });

    return rows;
  }
}


